.overlayWrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
}

.overlayContentWrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #000;
    padding: 50px;
    text-align: center;
    width: 85%;
    max-width: 400px;
    border-radius: 10px;
}

.authCopy {
    margin-bottom: 1.5em;
}

.loginButton {
    color: black;
}

.logo {
    display: block;
    width: 100px;
    margin: 0 auto 20px auto;
}

.quickComplete {
    position: absolute;
    bottom: 20px;
    right: 20px;
    z-index: 800;

    button {
        color: black;
    }
}

.questUnenrolledNotice {
    position: absolute;
    z-index: 1000;
    bottom: 20px;
    left: 20px;
    padding: 20px 20px;
    background-color: #000;
    color: white;
    font-size: 14px;
    border-radius: 5px;
    max-width: calc(100% - 40px);
    &.collapsed {
        padding: 0;
        background-color: transparent;
    }
    .enrolButton {
        background-color: #555;
        padding: 5px 10px;
        border-radius: 50px;
        font-size: 12px;
        font-weight: bold;
        margin-left: 10px;
        display: inline-block;
        cursor: pointer;
        &:first-child {
            margin-left: 0;
        }
    }
}
.info {
    position: fixed;
    bottom: 20px;
    left: 20px;
    z-index: 1000;
    color: black;
    background-color: white;
}
